<template>
  <div class="prices" v-if="product.prices">
    <!-- Silver Pricing -->
    <div v-if="memberLevel == 'silver'">
      <div class="rrp">*RRP: {{CurrencyFormatter(product.prices.retail)}}</div>
      <div class="member-price">Silver Price: {{CurrencyFormatter(product.prices.silver.price)}}
        <span v-if="product.prices.silver.saving_percent"> - Save {{product.prices.silver.saving_percent.toFixed(1)}}%
        </span>
      </div>

       <span class="goldPrice">Gold Price: {{CurrencyFormatter(product.prices.gold.price)}}
          <span v-if="product.prices.silver.saving_percent"> - Save {{product.prices.gold.saving_percent.toFixed(1)}}%</span></span>
      <div class="upgradePrompt" v-if="product.prices.gold.saving_percent > 0">
        <router-link
          :to="{name:'accountGoldUpgrade'}"
          class="btn btn-upgrade btn-block"
        >Upgrade to Gold now and save</router-link>
      </div>
    </div>
    <!-- Gold Pricing -->
    <div v-if=" memberLevel == 'gold'">
      <div class="member-price">Gold Price: {{CurrencyFormatter(product.prices.gold.price)}}<PriceBreakDown :member_price="product.member_price"/></div>
      <span class="rrp">*RRP: {{CurrencyFormatter(product.prices.retail)}}</span>
      <div
        class="red"
      >You're saving {{CurrencyFormatter(product.prices.gold.saving_amount)}}, that's {{product.prices.gold.saving_percent.toFixed(1)}}% off RRP!
      </div>
    </div>

    <!-- Platinum Pricing -->
    <div v-if=" memberLevel == 'platinum'">
      <div class="member-price">Gold Price: {{CurrencyFormatter(product.prices.platinum.price)}}<PriceBreakDown :member_price="product.member_price"/></div>
      <span class="rrp">*RRP: {{CurrencyFormatter(product.prices.retail)}}</span>
      <div
        class="red"
      >You're saving {{CurrencyFormatter(product.prices.platinum.saving_amount)}}, that's {{product.prices.platinum.saving_percent.toFixed(1)}}% off RRP!
      </div>
    </div>
    <!-- TODO platinum, staff and family -->
    <!-- Staff Pricing -->
    <div v-if="memberLevel == 'staff'">
      <div class="member-price">Staff Price: {{CurrencyFormatter(product.prices.staff.price)}}</div>
      <span class="rrp">*RRP: {{CurrencyFormatter(product.prices.retail)}}</span>
    </div>
  </div>
</template>

<script>
import { CurrencyFormatter } from "@/utils";

import { mapState } from "vuex";
import PriceBreakDown from "./ProductPriceBreakdown"

export default {
  name: "ProductPrices",
  components: {
		PriceBreakDown
	},
  props: ["product"],
  data() {
    return {};
  },
  methods: {
    CurrencyFormatter

  },
  mounted() {
    // send google impression on page load
    // this.$ga.ecommerce.addDetail({
    //   name: this.product.title,
    //   id: this.product.id,
    //   // category: 'Party Toys',
    //   brand: this.product.brand,
    //   price: this.product.member_price.price,
    // })
  },
  computed: {
    ...mapState({
      memberLevel: state => state.auth.memberLevel
    })
  }
};
</script>

<style lang="scss" scoped>
.prices {
  .member-price {
    font-weight: bold;
    font-size: 1.5em;
  }
  margin-bottom: 10px;
  .rrp {
    font-size: 1.1em;
    // color: grey;
  }
  .platinum {
    color: gold;
    font-size: 0.8em;
  }
  .goldPrice{
    font-size:1.1em;
  }
}

.wantToSave{
  font-size:1.3em;
  font-style: italic;
}
</style>
